<template>
  <v-card class="card-bg card-hd pt-4 px-4 pb-4 point-table-card" variant="elevated" elevation="0">
    <div class="d-flex ga-2">
      <v-btn variant="outlined" color="#2655f1" rounded="xl" @click="goBack">
        <v-icon start icon="mdi-arrow-left" />
        {{ $str.getKey('全局/返回') }}
      </v-btn>
      <v-btn color="success" rounded="xl" @click="handleRefreshCache">
        <v-icon start icon="mdi-refresh" />
        {{ $str.getKey('设备型号/刷新缓存') }}
      </v-btn>
      <v-btn color="#2655f1" rounded="xl" @click="handleAdd">
        <v-icon start icon="mdi-plus" />
        {{ $str.getKey('全局/新增') }}
      </v-btn>
    </div>
  </v-card>

  <v-card class="rounded-xl card-bg card-bd mt-4 point-table-card point-table-body" variant="elevated" elevation="0" :loading="tableLoading">
    <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
      <v-table fixed-header height="calc(100vh - 220px)" style="width: 100%; background: transparent"
        class="gm-table border-none">
        <thead>
          <tr>
            <th style="width: 100px">{{ $str.getKey('设备型号/数据地址位(10进制)') }}</th>
            <th style="width: 100px">{{ $str.getKey('设备型号/子分类') }}</th>
            <th style="width: 140px">{{ $str.getKey('设备型号/中文名') }}</th>
            <th style="width: 140px">{{ $str.getKey('设备型号/英文key') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/单位') }}</th>
            <th style="width: 90px">{{ $str.getKey('设备型号/数据类型') }}</th>
            <th style="width: 90px">{{ $str.getKey('设备型号/数据类别') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/默认值') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/最小值') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/最大值') }}</th>
            <th style="width: 70px">{{ $str.getKey('设备型号/比率') }}</th>
            <th style="width: 70px">{{ $str.getKey('设备型号/偏移量') }}</th>
            <th style="width: 60px">{{ $str.getKey('设备型号/排序') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/保存开关') }}</th>
            <th style="width: 80px">{{ $str.getKey('设备型号/是否展示') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/字典') }}</th>
            <th style="width: 150px">{{ $str.getKey('设备型号/备注') }}</th>
            <th style="width: 180px" class="text-center">{{ $str.getKey('全局/操作') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in modelList" :key="row.id" class="table-row">
            <td class="text-medium-emphasis">{{ fmt(row.address) }}</td>
            <td>{{ fmt(row.dataClassification) }}</td>
            <td class="text-primary font-weight-medium">{{ fmt(row.nameCn) }}</td>
            <td class="text-orange">{{ row.nameEn }}</td>
            <td>{{ fmt(row.unit) }}</td>
            <td>{{ row.dataType }}</td>
            <td>
              <v-chip :color="row.dataCategory == 'YC' ? 'info' : 'warning'" size="x-small" variant="flat">
                {{ row.dataCategory == 'YC' ? $str.getKey('设备型号/遥测') : $str.getKey('设备型号/遥信') }}
              </v-chip>
            </td>
            <td class="text-medium-emphasis">{{ fmt(row.defaultValue) }}</td>
            <td class="text-medium-emphasis">{{ fmt(row.lowerLimit) }}</td>
            <td class="text-medium-emphasis">{{ fmt(row.upperLimit) }}</td>
            <td class="text-medium-emphasis">{{ fmt(row.ratio) }}</td>
            <td class="text-medium-emphasis">{{ fmt(row.offset) }}</td>
            <td class="text-medium-emphasis">{{ fmt(row.sort) }}</td>
            <td>
              <span :class="row.saveSwitch == 0 ? 'text-success' : 'text-error'">
                {{ row.saveSwitch == 0 ? $str.getKey('设备型号/保存') : $str.getKey('设备型号/不保存') }}
              </span>
            </td>
            <td>
              <v-chip :color="row.isHide == 0 ? 'success' : 'error'" size="x-small" variant="flat">
                {{ row.isHide == 0 ? $str.getKey('设备型号/展示') : $str.getKey('设备型号/隐藏') }}
              </v-chip>
            </td>
            <td class="text-truncate" style="max-width: 120px;">{{ fmt(row.readConverter) }}</td>
            <td class="text-medium-emphasis text-truncate" style="max-width: 150px;">{{ fmt(row.remark) }}</td>
            <td>
              <div class="d-flex justify-center ga-2">
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="handleEdit(row)">{{ $str.getKey('全局/编辑') }}</v-btn>
                <v-btn variant="text" color="#FF6A46" rounded="xl" @click="handleDelete(row)">{{ $str.getKey('全局/删除') }}</v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>

    <div v-if="modelList.length === 0" class="text-center py-12 text-medium-emphasis">
      {{ $str.getKey('全局/暂无数据') }}
    </div>
  </v-card>

  <v-dialog v-model="editModelVisible" max-width="740px" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <span style="color: #2655F1;">{{ $str.getKey('设备型号/编辑模型').substring(0, 2) }}</span>
          <span>{{ $str.getKey('设备型号/编辑模型').substring(2) }}</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="handleCancelModel" />
      </div>
      <v-card-text class="pa-8 pt-4 pb-2 overflow-auto" style="max-height: 72vh;">
        <v-form ref="formRef" v-model="formValid" :disabled="loading">
          <div class="form-grid-2">
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据地址位(10进制)') }}</label>
              <v-text-field v-model="form.address" :placeholder="$str.getKey('设备型号/数据地址位(10进制)')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.address"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/子分类') }}</label>
              <v-text-field v-model="form.dataClassification" :placeholder="$str.getKey('设备型号/子分类')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.dataClassification"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/中文名') }}</label>
              <v-text-field v-model="form.nameCn" :placeholder="$str.getKey('设备型号/中文名')" variant="outlined" density="compact"
                hide-details class="gm-input" :rules="rules.nameCn"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/英文key') }}</label>
              <v-text-field v-model="form.nameEn" :placeholder="$str.getKey('设备型号/英文key')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.nameEn"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/单位') }}</label>
              <v-text-field v-model="form.unit" :placeholder="$str.getKey('设备型号/单位')" variant="outlined" density="compact"
                hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据类型') }}</label>
              <v-select v-model="form.dataType" :items="dataTypeItems" :placeholder="$str.getKey('设备型号/数据类型')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-select>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据类别') }}</label>
              <v-select v-model="form.dataCategory" :items="dataCategoryItems" :placeholder="$str.getKey('设备型号/数据类别')"
                variant="outlined" density="compact" hide-details class="gm-input"></v-select>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/默认值') }}</label>
              <v-text-field v-model="form.defaultValue" :placeholder="$str.getKey('设备型号/默认值')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/最小值') }}</label>
              <v-text-field v-model="form.lowerLimit" :placeholder="$str.getKey('设备型号/最小值')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/最大值') }}</label>
              <v-text-field v-model="form.upperLimit" :placeholder="$str.getKey('设备型号/最大值')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/比率') }}</label>
              <v-text-field v-model="form.ratio" :placeholder="$str.getKey('设备型号/比率')" variant="outlined" density="compact"
                hide-details class="gm-input" :rules="rules.ratio"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/偏移量') }}</label>
              <v-text-field v-model="form.offset" :placeholder="$str.getKey('设备型号/偏移量')" variant="outlined" density="compact"
                hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/排序') }}</label>
              <v-text-field v-model.number="form.sort" :placeholder="$str.getKey('设备型号/排序')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.sort"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/保存开关') }}</label>
              <v-select v-model="form.saveSwitch" :items="saveSwitchItems" :placeholder="$str.getKey('设备型号/保存开关')"
                variant="outlined" density="compact" hide-details class="gm-input"></v-select>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/是否展示') }}</label>
              <v-select v-model="form.isHide" :items="isHideItems" :placeholder="$str.getKey('设备型号/是否展示')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-select>
            </div>
            <div class="form-group grid-full">
              <label>{{ $str.getKey('设备型号/字典') }}</label>
              <div class="text-grey mb-2">{{ dictStr }}</div>
              <div class="dict-table-wrapper">
                <v-table density="compact" class="dict-table border-none">
                  <thead>
                    <tr>
                      <th style="width: 45%">{{ $str.getKey('设备型号/值') }}</th>
                      <th style="width: 45%">{{ $str.getKey('设备型号/描述') }}</th>
                      <th style="width: 100px" class="text-center">{{ $str.getKey('全局/操作') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in formDict" :key="index">
                      <td>
                        <v-text-field v-model.trim="row.key" maxlength="50" variant="outlined" density="compact"
                          hide-details class="dict-input"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model.trim="row.value" maxlength="50" variant="outlined" density="compact"
                          hide-details class="dict-input"></v-text-field>
                      </td>
                      <td class="text-center">
                        <v-btn variant="text" color="#FF6A46" rounded="xl" @click="handleDeleteDict(row)">
                          {{ $str.getKey('全局/删除') }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
              <v-btn variant="text" color="#2655f1" @click="handleAddDict" class="mt-2 align-self-start">
                <v-icon start icon="mdi-plus" />
                {{ $str.getKey('全局/新增') }}
              </v-btn>
            </div>
            <div class="form-group grid-full">
              <label>{{ $str.getKey('设备型号/备注') }}</label>
              <v-textarea v-model="form.remark" :placeholder="$str.getKey('设备型号/备注')" variant="outlined" density="compact"
                rows="2" counter maxlength="50" hide-details class="gm-input"></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <div class="mr-auto d-flex align-center" v-if="isAdd">
          <v-checkbox v-model="continueCreateNext" :label="$str.getKey('设备型号/继续创建下一个')" hide-details
            density="compact"></v-checkbox>
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" class="ml-2 text-grey">mdi-information-outline</v-icon>
            </template>
            {{ $str.getKey('设备型号/勾选后不关闭弹框，基于现有数据继续创建下一个点表') }}
          </v-tooltip>
        </div>
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
          @click="handleCancelModel">{{ $str.getKey('全局/取消') }}</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="loading"
          @click="handleSaveModel(formRef)">{{ $str.getKey('全局/保存') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { getModelPointList, deleteModelPoint, insertModelPoint, updateModelPoint, refreshCache } from '@/api/device/model';
import { reactive, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { eui } from 'ems-ui';


const router = useRouter()
const $str = window.$str

const modelId = computed(() => {
  return router.currentRoute.value.query.modelId
})
const modelList = ref([])
const total = ref(0)
const editModelVisible = ref(false)
const loading = ref(false)
const tableLoading = ref(false)
const isAdd = ref(false)
const formRef = ref(null)
const formValid = ref(false)
const continueCreateNext = ref(false)

const dataTypeItems = ['float', 'int', 'string']
const dataCategoryItems = [
  { value: 'YC', title: computed(() => $str.getKey('设备型号/遥测')).value },
  { value: 'YX', title: computed(() => $str.getKey('设备型号/遥信')).value }
]
const saveSwitchItems = [
  { value: 0, title: computed(() => $str.getKey('设备型号/保存')).value },
  { value: 1, title: computed(() => $str.getKey('设备型号/不保存')).value }
]
const isHideItems = [
  { value: 0, title: computed(() => $str.getKey('设备型号/展示')).value },
  { value: 1, title: computed(() => $str.getKey('设备型号/隐藏')).value }
]

const rules = reactive({
  address: [v => !!v || $str.getKey('设备型号/请输入数据地址位(10进制)')],
  dataClassification: [v => !!v || $str.getKey('设备型号/请输入子分类')],
  nameCn: [v => !!v || $str.getKey('设备型号/请输入中文名')],
  nameEn: [v => !!v || $str.getKey('设备型号/请输入英文key')],
  dataType: [v => !!v || $str.getKey('设备型号/请输入数据类型')],
  dataCategory: [v => !!v || $str.getKey('设备型号/请输入数据类别')],
  ratio: [v => !!v || $str.getKey('设备型号/请输入比率')],
  sort: [
    v => {
      if (!Number.isInteger(v)) {
        return $str.getKey('设备型号/排序必须是整数')
      }
      return true
    }
  ]
})

function fmt(value) {
  return value ? value : '--'
}

const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
})

const formDict = ref([])

const dictStr = computed(() => {
  return formDict.value.map(item => {
    if (item.key == '' || item.value == '') {
      return ''
    }
    return `${item.key}:${item.value}`
  }).filter(item => item != '').join(', ')
})

function handleAddDict() {
  formDict.value.push({
    key: '',
    value: '',
  })
}

function handleDeleteDict(item) {
  formDict.value = formDict.value.filter(it => it !== item)
}

const form = reactive({
  address: '',
  dataClassification: '',
  nameCn: '',
  nameEn: '',
  unit: '',
  dataType: '',
  dataCategory: '',
  defaultValue: '',
  lowerLimit: '',
  upperLimit: '',
  ratio: '',
  offset: '',
  sort: 0,
  saveSwitch: '',
  isHide: '',
  readConverter: '',
  remark: '',
  modelId: modelId.value,
})

async function fetchModelList() {
  tableLoading.value = true
  try {
    console.log('modelId.value', modelId.value)
    const res = await getModelPointList(modelId.value)
    console.log('res', res)
    modelList.value = res.data
    total.value = res.total
  } finally {
    tableLoading.value = false
  }
}
fetchModelList()

function handleEdit(row) {
  console.log('row', row)
  resetForm()
  Object.assign(form, row)

  setFormDict(row.readConverter)

  editModelVisible.value = true
  isAdd.value = false
}

function setFormDict(readConverter) {
  try {
    if (!readConverter) {
      formDict.value = []
      return
    }
    const dict = readConverter.split(',').map(item => {
      const [key, value] = item.split(':')
      return {
        key,
        value,
      }
    })

    formDict.value = dict
  } catch (error) {
    console.log('error', error)
    formDict.value = []
  }
}

async function handleDelete(row) {
  console.log('row', row)
  const ok = await eui.confirm('系统提示', '确定要删除吗?')
  if (ok) {
    const r = await deleteModelPoint(row)
    if (r.code == 200) {
      eui.showToast('操作成功', 'success')
      fetchModelList()
    }
  }
}

function handleAdd() {
  console.log('handleAdd')
  isAdd.value = true
  editModelVisible.value = true
  formDict.value = []

  resetForm()
}

function resetForm() {
  form.address = ''
  form.dataClassification = ''
  form.nameCn = ''
  form.nameEn = ''
  form.unit = ''
  form.dataType = ''
  form.dataCategory = ''
  form.defaultValue = ''
  form.lowerLimit = ''
  form.upperLimit = ''
  form.ratio = ''
  form.offset = ''
  form.sort = 0
  form.saveSwitch = ''
  form.isHide = ''
  form.readConverter = ''
  form.remark = ''
  form.modelId = modelId.value
}

function handleCancelModel() {
  editModelVisible.value = false
}

async function handleSaveModel(formEl) {
  form.readConverter = dictStr.value

  console.log('form', form)

  if (!formEl) {
    console.log('formEl is null or undefined, returning early')
    return
  }

  const { valid } = await formEl.validate()

  console.log('valid', valid)

  if (!valid) {
    return
  }

  const fn = isAdd.value ? insertModelPoint : updateModelPoint
  const r = await fn(form)
  if (r.code == 200) {
    eui.showToast($str.getKey('设备型号/操作成功'), 'success')
    fetchModelList()

    if (continueCreateNext.value && isAdd.value) {
    } else {
      editModelVisible.value = false
    }
  }
}

function goBack() {
  router.back()
}

async function handleRefreshCache() {
  const r = await refreshCache(modelId.value)
  if (r.code == 200) {
    eui.showToast(r.msg, 'success')
    fetchModelList()
  }
}
</script>




<style scoped lang="scss">
.card-bd {
  border-radius: 30px !important;
}

.card-hd {
  border-radius: 0 0 30px 30px !important;
}

.point-table-card {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.point-table-body {
  min-height: 0;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  overflow: hidden;
  padding: 24px 16px 0;
}

.table-wrapper {
  min-width: 0;
  max-width: 100%;
}

.dict-table-wrapper {
  border: 1px solid var(--color-td-border, #e9efff);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.dict-table {
  background: #fff !important;

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 42px !important;
    padding: 0 16px !important;
    white-space: nowrap;
  }

  :deep(tbody tr),
  :deep(td) {
    background: #fff !important;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 48px !important;
    padding: 6px 16px !important;
    white-space: nowrap;
  }
}

.dict-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 10px !important;
    box-shadow: none !important;

    .v-field__outline {
      display: none !important;
    }
  }
}

.gm-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.v-table__wrapper) {
    overflow-x: auto !important;
  }

  :deep(table) {
    min-width: 1500px;
  }

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(th:last-child),
  :deep(td:last-child) {
    position: sticky;
    right: 0;
    box-shadow: -8px 0 12px rgba(15, 23, 42, 0.06);
  }

  :deep(th) {
    z-index: 5 !important;
  }

  :deep(th:last-child) {
    z-index: 6 !important;
    background: #f8fafc !important;
  }

  :deep(td:last-child) {
    z-index: 1;
    background: #fff !important;
  }
}
.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 24px !important;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}

.form-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #2E2E2E;
  }

  &.grid-full {
    grid-column: span 2;
  }
}

.gm-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 15px !important;
    box-shadow: none !important;
    padding-inline: 4px !important;

    .v-field__outline {
      display: none !important;
    }

    input,
    textarea,
    .v-select__selection {
      font-size: 14px;
      color: rgba(46, 46, 46, 0.8);
      font-weight: 400;
    }
  }
}

.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #545454 !important;
  box-shadow: none !important;
}

.gm-btn-primary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}
</style>
